import script from "./transportContractReview.vue?vue&type=script&setup=true&lang=js"
export * from "./transportContractReview.vue?vue&type=script&setup=true&lang=js"

import "./transportContractReview.vue?vue&type=style&index=0&id=642bb506&lang=less"

const __exports__ = script;

export default __exports__